import RFirebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import { ISettings } from 'src/types/app';
import { FIREBASE_EVENT_HANDLER } from './handlers';
import { EVENTS_MAP, TEvents } from 'src/constants/events';

class Firebase {
  private isInitialized: boolean = false;
  public analytics: RFirebase.analytics.Analytics | undefined;
  public analyticsDook: RFirebase.app.App = RFirebase.initializeApp(
    {
      apiKey: 'AIzaSyBukrNFqBUG81Nzp-ZwrJshtnbphWtmxhY',
      authDomain: 'dook---web-service.firebaseapp.com',
      projectId: 'dook---web-service',
      storageBucket: 'dook---web-service.appspot.com',
      messagingSenderId: '201036057719',
      appId: '1:201036057719:web:28733fae7d5bb74eb88a72',
      measurementId: 'G-KLBJY47R1E',
    },
    'Dook'
  );

  public setConfig(config: ISettings['firebase']) {
    if (
      config &&
      config.appId &&
      config.apiKey &&
      config.authDomain &&
      config.measurementId &&
      config.projectId &&
      config.messagingSenderId &&
      config.storageBucket
    ) {
      RFirebase.initializeApp(config);
      this.analytics = RFirebase.analytics();
      this.isInitialized = true;
    }
  }

  public logEvent(event: TEvents[keyof TEvents], params: any = {}): void {
    try {
      if (this.analytics && this.isInitialized) {
        const parameters = FIREBASE_EVENT_HANDLER(event, params);
        this.analytics.logEvent(EVENTS_MAP[event], parameters);
        this.analyticsDook.analytics().logEvent(EVENTS_MAP[event], parameters);
      }
    } catch (error: any) {
      console.error(error);
    }
  }
}
export const firebase = new Firebase();
